<template>
  <div class="logo">
    <router-link :to="{name:'vip-list'}">
      <a-row class="title" v-if="showTitle" justify="center">
        <a-col>
          <p>奕宁健康</p>
        </a-col>
        <a-col>
          <p>会员服务后台管理系统</p>
        </a-col>
      </a-row>
      <div v-else style="padding-left: 24px">
      <SvgIcon  name="logo"/>
      </div>
    </router-link>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon/SvgIcon";

export default {
  name: "Logo",
  components: {
    SvgIcon,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  }
}
</script>

<style scoped lang="less">
  .title {
    color: #e8e8e8;
    font-size: 16px;
  }
</style>